export default __webpack_public_path__ + "static/screen-classic-mac-laptop-b20d8ea4100e4cf3526d2d6dba4260ec.webp";